import { REPEAT_MODE } from '../constants'

/** Summary must never invent a cadence when repeat mode is does_not_repeat. */
export const summarizeRepeat = repeat => {
  const mode = repeat?.mode || repeat?.type
  if (!mode || mode === REPEAT_MODE.doesNotRepeat) return 'does not repeat'
  if (mode === REPEAT_MODE.oncePerAnchorOccurrence) return 'once per anchor occurrence'
  if (mode === REPEAT_MODE.everyNDays) return `repeats every ${repeat.intervalDays || 'N'} days`
  if (mode === REPEAT_MODE.weeklyOnSelectedDays) {
    const days = (repeat.weekdays || []).join(', ') || 'selected days'
    return `repeats weekly on ${days}`
  }
  if (mode === REPEAT_MODE.everyNWeeks) return `repeats every ${repeat.intervalWeeks || 'N'} weeks`
  if (mode === REPEAT_MODE.everyNHours) return `repeats every ${repeat.intervalHours || 'N'} hours`
  if (mode === REPEAT_MODE.everyNMinutes) return `repeats every ${repeat.intervalMinutes || 'N'} minutes`
  if (mode === REPEAT_MODE.everyNMonths) return `repeats every ${repeat.months || 'N'} months`
  if (mode === REPEAT_MODE.monthlyOnDay) {
    const days = repeat.daysOfMonth?.length
      ? repeat.daysOfMonth.join(', ')
      : repeat.dayOfMonth || 'X'
    return `repeats every ${repeat.months || 'N'} months on day ${days}`
  }
  if (mode === REPEAT_MODE.chapterIntervalUniform) return 'repeats on a uniform chapter interval'
  if (mode === REPEAT_MODE.chapterIntervalExplicit) return 'repeats on an explicit chapter interval list'
  if (mode === REPEAT_MODE.episodicOnSubmission) return 'opens a new instance on each submission'
  return ''
}
